import { Check, Loader2, type LucideIcon } from 'lucide-react';

import { Button } from '@design-system';

interface StepCompletedOverlayProps {
  isVisible: boolean;
  title?: string;
  description?: string;
  buttonText?: string;
  buttonLoading?: boolean;
  icon?: LucideIcon;
  onContinue: () => void;
}

export function StepCompletedOverlay({
  isVisible,
  title = 'Step completed',
  description,
  buttonText = 'Continue',
  buttonLoading = false,
  icon: Icon = Check,
  onContinue,
}: StepCompletedOverlayProps) {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/80 backdrop-blur-[2px]">
      <div className="flex flex-col items-center gap-5 px-6 text-center">
        <div className="flex size-12 items-center justify-center rounded-full bg-green-600">
          <Icon
            className="size-6 text-white"
            strokeWidth={2.5}
          />
        </div>
        <div className="space-y-2">
          <p className="text-base font-medium text-gray-950">{title}</p>
          {description && <p className="text-foreground text-sm">{description}</p>}
        </div>
        <Button
          onClick={onContinue}
          variant="outline"
          className="mt-1 px-6"
          disabled={buttonLoading}
        >
          {buttonLoading ? (
            <span className="flex items-center gap-2">
              <Loader2 className="size-4 animate-spin" />
              Loading...
            </span>
          ) : (
            buttonText
          )}
        </Button>
      </div>
    </div>
  );
}
